module.exports = "<p>\r\n    foro works!\r\n</p>"